// src/shared/components/ui/EmptyState.jsx
import React from 'react';
import styles from './EmptyState.module.css';
import Button from './Button';

/**
 * حالة الفراغ — تظهر حين لا توجد بيانات
 *
 * @param {string}   icon
 * @param {string}   title
 * @param {string}   message
 * @param {string}   actionLabel  - نص زر الإجراء (اختياري)
 * @param {Function} onAction
 */
const EmptyState = ({
  icon        = '📭',
  title       = 'لا توجد بيانات',
  message     = 'جرّب تعديل الفلاتر أو أضف عنصراً جديداً.',
  actionLabel,
  onAction,
}) => (
  <div className={styles.container}>
    <div className={styles.icon}>{icon}</div>
    <h2 className={styles.title}>{title}</h2>
    <p className={styles.message}>{message}</p>
    {actionLabel && onAction && (
      <Button variant="primary" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;